"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = void 0;
var _react = require("react");
var _base = require("@mui/base");
var _Unstable_Popup = require("@mui/base/Unstable_Popup");
var _dom = require("@floating-ui/dom");
var _classes = require("../../common/classes");
var _helpers = require("../../common/helpers");
var _TextField = require("../TextField");
var _Select = require("../Select");
var _SelectOption = require("../SelectOption");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "helperText", "error", "required", "options", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Autocomplete = exports.Autocomplete = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _props$id;
  var label = _ref.label,
    helperText = _ref.helperText,
    error = _ref.error,
    required = _ref.required,
    options = _ref.options,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAutocomplete = (0, _base.useAutocomplete)(_objectSpread({
      options: options
    }, props)),
    anchorEl = _useAutocomplete.anchorEl,
    getInputProps = _useAutocomplete.getInputProps,
    getInputLabelProps = _useAutocomplete.getInputLabelProps,
    getListboxProps = _useAutocomplete.getListboxProps,
    getOptionProps = _useAutocomplete.getOptionProps,
    getRootProps = _useAutocomplete.getRootProps,
    groupedOptions = _useAutocomplete.groupedOptions,
    popupOpen = _useAutocomplete.popupOpen,
    setAnchorEl = _useAutocomplete.setAnchorEl,
    value = _useAutocomplete.value;
  var generatedID = (0, _react.useId)();
  var inputID = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : generatedID;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", _objectSpread(_objectSpread({
      htmlFor: inputID
    }, getInputLabelProps()), {}, {
      className: (0, _classes.labelClasses)({
        disabled: Boolean(props.disabled),
        error: Boolean(error)
      }),
      children: label
    })), required && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "aria-label": "required",
      className: (0, _helpers.cn)((0, _classes.requiredClasses)({
        disabled: Boolean(props.disabled)
      })),
      children: "*"
    }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.helperClasses)({
        disabled: Boolean(props.disabled),
        className: 'mb-3'
      })),
      children: helperText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
      ref: setAnchorEl,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.ClassNameConfigurator, {
        disableDefaultClasses: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Input, {
          id: inputID,
          ref: ref,
          slotProps: {
            root: {
              className: (0, _helpers.cn)((0, _TextField.rootClasses)({
                error: Boolean(error),
                disabled: Boolean(props.disabled),
                multiline: false
              }))
            },
            input: _objectSpread(_objectSpread({}, getInputProps()), {}, {
              className: (0, _TextField.inputClasses)({
                size: size,
                disabled: Boolean(props.disabled)
              })
            })
          }
        })
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Unstable_Popup.Unstable_Popup, {
      open: popupOpen,
      anchor: anchorEl,
      middleware: [(0, _dom.autoPlacement)(), (0, _dom.size)({
        apply: function apply(_ref2) {
          var rects = _ref2.rects,
            elements = _ref2.elements;
          Object.assign(elements.floating.style, {
            minWidth: 'fit-content',
            width: "".concat(rects.reference.width, "px"),
            zIndex: 1301
          });
        }
      })],
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", _objectSpread(_objectSpread({}, getListboxProps()), {}, {
        className: (0, _Select.listboxClasses)(),
        children: [groupedOptions.map(function (option, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", _objectSpread(_objectSpread({}, getOptionProps({
            option: option,
            index: index
          })), {}, {
            className: (0, _SelectOption.optionClasses)({
              selected: (value === null || value === void 0 ? void 0 : value.value) === option.value,
              disabled: false
            }),
            children: option.label
          }));
        }), groupedOptions.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: (0, _SelectOption.optionClasses)(),
          children: "No results"
        })]
      }))
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.errorClasses)()),
      children: error
    })]
  });
});